import { defineMessages } from 'react-intl';

export const objectBrowserMessages = defineMessages({
  SearchInputPlaceholder: {
    id: 'Search content',
    defaultMessage: 'Search content',
  },
  SelectedItems: {
    id: 'Selected items',
    defaultMessage: 'Selected items',
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
  search: {
    id: 'Search SVG',
    defaultMessage: 'Search SVG',
  },
  CancelSearch: {
    id: 'Cancel Search',
    defaultMessage: 'Cancel Search',
  },
  iconView: {
    id: 'Icon View',
    defaultMessage: 'Icon View',
  },
  listView: {
    id: 'List View',
    defaultMessage: 'List View',
  },
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  of: { id: 'Selected items - x of y', defaultMessage: 'of' },
  Local: {
    id: 'Local',
    defaultMessage: 'Local',
  },
  Global: {
    id: 'Global',
    defaultMessage: 'Global',
  },
  Language: {
    id: 'Language',
    defaultMessage: 'Language',
  },
  UploadFile: {
    id: 'Upload File',
    defaultMessage: 'Upload File',
  },
  SortByDefault: {
    id: 'Sort by Default',
    defaultMessage: 'Sort by Default',
  },
  SortByAlphabetical: {
    id: 'Sort by Alphabetical',
    defaultMessage: 'Sort by Alphabetical',
  },
  FileUploadSuccess: {
    id: 'Uploaded {filename}',
    defaultMessage: 'Uploaded {filename}',
  },
  FileUploadError: {
    id: 'Upload failed: {error}',
    defaultMessage: 'Upload failed: {error}',
  },
  fileTooLarge: {
    id: 'fileTooLarge',
    defaultMessage: 'This website does not accept files larger than {limit}',
  },
  loadMoreResults: {
    id: 'Load More Results',
    defaultMessage: 'Load More Results',
  },
});
